import React from "react";
import { connect } from "react-redux";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { bucketActions } from "redux/actions/bucket";
import { IAppState } from "redux/reducers";
import { ConfirmDialog } from "components/shared-ui/dialogs/common/confirm-dialog/confirm-dialog";
import styles from "./delete-confirmation.module.scss";


const mapDispatchToProps = (
  dispatch: ThunkDispatch<IAppState, void, Action>
) => {
  return {
    closeDeleteConfirmation: () => {
      dispatch(bucketActions.deleteConfirmation.close());
    }
  };
};

const mapStateToProps = (state: IAppState) => ({
  isOpen: state.bucket.deleteConfirmation.isOpen,
  data: state.bucket.deleteConfirmation.data,
});

export interface IDeleteConfirmationProps extends 
    ReturnType<typeof mapDispatchToProps>,
    ReturnType<typeof mapStateToProps> {
  onDelete: (bucketId: string) => void;
}

export const DeleteConfirmation = connect(mapStateToProps, mapDispatchToProps)((props: IDeleteConfirmationProps) => {
  function handleConfirm() {
    props.onDelete(props.data.id);
    props.closeDeleteConfirmation();
  }

  return (
    <ConfirmDialog
      testId="delete-bucket-confirmation"
      title="Delete Bucket"
      confirmText="Confirm"
      open={props.isOpen}
      onClose={props.closeDeleteConfirmation}
      onConfirm={handleConfirm}
    >
      <div className={styles.content}>
        Are you sure you want to delete <strong>{props.data?.name}</strong> bucket from Myota? All data will be lost.
      </div>
    </ConfirmDialog>
  );
});
